<template>
  <div class="teleInfos">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input class="seachInput" v-model="cellphone"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_Adminphone')"></el-input>
        </el-form-item>        
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
        <el-upload class="upload-demo" ref="uploading" action :on-remove="handleRemove" :on-change="handleSuccess"
          :on-exceed="outlimit" :on-error="uploadErr1" :limit="1" accept=".xlsx,.xls" :file-list="fileList"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">{{$t('lang.btn_selectExcel')}}</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">
            {{$t('lang.feePay.btn_fee_import')}}</el-button>
        </el-upload>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="addTel()">{{$t('lang.btn_add')}}</el-button>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="teleInfosListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="orderId" :label="$t('lang.lab_payOrder')"></el-table-column>
        <el-table-column prop="cellphone" :label="$t('lang.lab_Adminphone')"></el-table-column>
        <el-table-column prop="nickName" :label="$t('lang.lab_nickName')"></el-table-column>
        <el-table-column prop="payPrice" :label="$t('lang.lab_payPrice')"></el-table-column>
        
        <!-- 操作 -->
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width4">
          <template slot-scope="scope">
            <el-button class="orange" @click="delTele(scope.row.orderId)">{{$t('lang.btn_delete')}}</el-button>        
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="600px" @closed="handleDialogClosed">
      <!-- 表单验证 -->
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_Adminphone')" prop="cellphone">
          <el-input v-model="form.cellphone" :placeholder="$t('lang.lab_Adminphone')" maxlength="11" @input="keyMobile"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_payPrice')" prop="payPrice">
          <el-input v-model="form.payPrice" :placeholder="$t('lang.lab_payPrice')" maxlength="6" @input="keyBuildArea">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_buyNum')" prop="buyNum">
							<el-input v-model.number="form.buyNum"
								:placeholder="$t('lang.lab_please_Input')+$t('lang.lab_buyNum')" class="input-width"
								maxlength="50"></el-input>
				</el-form-item>
        <el-form-item :label="$t('lang.lab_skuInfo')" prop="skuInfo">
          <el-input v-model="form.skuInfo" :placeholder="$t('lang.lab_skuInfo')" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="积分同步" prop="isSyncPoint">
					<el-radio v-model="form.isSyncPoint" :label=1>{{$t('lang.lab_isYes')}}</el-radio>
					<el-radio v-model="form.isSyncPoint" :label=0>{{$t('lang.lab_isNo')}}</el-radio>
				</el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>  
  import { mapGetters } from 'vuex'
  export default {
    name:'/manage/main.appOrder',
    data() {
      return {
        isDisabled: true, // 按钮置灰
        saveData: '', // 存储json字符串
        name: '', // 名称
        content: '', // 电话
        serviceTime: '', // 服务时间
        editId: '', // 接收参数
        titleShow: '', // 弹框标题
        diaIsShow: false, // 弹框是否显示
        gardenId: '', // 小区编号
        pageNum: 1, // 页数
        pageSize: 10, // 每页数量
        pageCount: 0, // 总页数
        tableData: [], // 表单数据
        multipleSelection: [], // 多选框
        cellphone: '', // 手机或序号内容input
        type: '', // 判断checkbox的值
        uploadFile: '',
        fileList: [], // 上传
        fjTypes: this.$i18n.t('lang.fjTypes'), // 下拉列表
        teleInfosListcheckbox: require('@/config/enum').teleInfosListcheckbox, // 是否隐藏复选框
        form: {
          cellphone: '',
          payPrice: '',
          buyNum: '',
          skuInfo: '',
          isSyncPoint: 0
        },
        rules: {
          cellphone: [{
            required: true,
            message: this.$i18n.t('lang.pla_Adminphone'),
            trigger: 'blur'
          }],
          payPrice: [{
            required: true,
            message: this.$i18n.t('lang.ple_payPrice'),
            trigger: 'blur'
          }],
          buyNum: [{
            required: true,
            message: this.$i18n.t('lang.ple_buyNum'),
            trigger: 'blur'
          }],
          skuInfo: [{
            required: true,
            message: this.$i18n.t('lang.ple_skuInfo'),
            trigger: 'blur'
          }]
        },
      }
    },
    // 初始化
    created() {
      this.topics()
    },
    // 监听小区编号
    watch: {
      '$store.state.allGardenId': function (newFlag, oldFlag) {
        this.gardenId = this.$store.state.allGardenId
        this.topics()
      },
      form: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 用户名只能输入数字
      keyBA() {
        // 仅保留数字和"."
        this.form.totalNum = this.form.totalNum.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (this.form.totalNum.indexOf('.') < 0 && this.form.totalNum != '') {
          this.form.totalNum = parseFloat(this.form.totalNum)
        }
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      topics() {
        let loading = this.$loading()
        this.$get(
          `/sklOrder?pageNo=${this.pageNum}&pageSize=${this.pageSize}&cellphone=${this.cellphone}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
       // 提交
      submit() {
        this.pageNo = 1
        this.topics()
      },
      // 添加电话
      addTel() {
        this.editId = ''
        this.titleShow = this.$i18n.t('lang.btn_add')
        this.form.cellphone = ''
        this.form.payPrice = ''
        this.form.buyNum = 0
        this.form.skuInfo = ''
        this.form.isSyncPoint = 1
        this.diaIsShow = true
      },
      // 修改电话信息
      changeTel(row) {
        this.editId = row.id
        this.titleShow = this.$i18n.t('lang.lab_changePark')
        this.form.cellphone = row.cellphone
        this.form.payPrice = Number(row.totalNum)
        this.form.isRepeat = row.isRepeat + ''
        this.saveData = JSON.stringify(this.form)
        this.diaIsShow = true
      },
      addPlace(id) {
        this.$router.push({
					path: '/manage/carPlaceList',
					query: {
						id: id
					}
				})
      },
      addGate(id) {
        this.$router.push({
					path: '/manage/carGateList',
					query: {
						id: id
					}
				})
      },
      // 删除
      delTele(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`sklOrder/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.editId === '') {
              let params = {
                cellphone: this.form.cellphone,
                payPrice: this.form.payPrice,
                buyNum: this.form.buyNum,
                skuInfo: this.form.skuInfo,
                isSyncPoint: this.form.isSyncPoint
              }
              if (this.gardenId === 0) {
                this.$message.error(this.$i18n.t('lang.reportPleaseSelectVillage'))
                return
              }
              let loading = this.$loading()
              this.$post(`/sklOrder/`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              let loading = this.$loading()
              let params = {
                parkName: this.form.parkName,
                totalNum: this.form.totalNum,
                isRepeat: this.form.isRepeat
              }
              this.$patch(`/carPark/${this.editId}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              console.log(params.type)
            }
          }
        })
      },
      // 下载模板
      download() {
        if (navigator.onLine) {
          window.open(require('@/config/enum').mould)
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 文件上传数量超过提醒
      outlimit() {
        this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
      },
      // 移除附件
      handleRemove(file, fileList) {
        console.log('Remove Success!', file, fileList)
        this.fileList = []
        this.uploadFile.length = 0
      },
      // 文件上传
      handleSuccess(e) {
        console.log('Upload Success!', e)
        this.uploadFile = e.raw
      },
      // 导入业主
      submitUpload() {
        if (this.uploadFile.length < 1) {
          this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc'))
        } else {
          let formData = new FormData()
          formData.append('excelFile', this.uploadFile)
          let loading = this.$loading()
          this.$postFormData(`/inputSklOrder/`, formData).then(
            res => {
              loading.close()
              this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
              // this.commit()
              this.fileList = []
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
       // 上传文件的断网
      uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
          const loading = this.$loading()
          setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }, 500)
        }
      },
      clear() {
        this.$refs.form.resetFields()
        this.form.parkName = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.clear()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.topics()
      },
      keyBuildArea() {
        // 仅保留数字和"."
        this.form.payPrice = this.form.payPrice.replace(/[^\d.]/g, '') 
        // 两个连续的"."仅保留第一个"."
        this.form.payPrice = this.form.payPrice.replace(/\.{2,}/g, '.')
        // 去除其他"."
        this.form.payPrice = this.form.payPrice.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
        // 限制只能输入两个小数
         this.form.payPrice = this.form.payPrice.replace(/^(\d+)\.(\d\d).*$/, '$1.$2') 
        // 首位是0的话去掉
        if (this.form.payPrice.indexOf('.') < 0 && this.form.payPrice != '') { 
          this.form.payPrice = parseFloat(this.form.payPrice)
        }
      },
      // 手机号码输入限制
      keyMobile() {
        // 仅保留数字
        this.form.cellphone = this.form.cellphone.replace(/[^\d]/g, '')
      }, 
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.topics()
      }
    }
  }
</script>

<style lang="scss">
</style>